/**
 * Enum that describes the available input types
 */
export enum InputType {
    color = "color",
    date = "date",
    email = "email",
    month = "month",
    number = "number",
    password = "password",
    text = "text",
    url = "url"
}